<template>
	<div>
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item label="年份：">
				<el-date-picker
					v-model="inputYear"
					type="year"
					:clearable="false"
					value-format="yyyy"
					format="yyyy年"
					placeholder="选择年份"
					:editable="false"
					size="small"
					@change="changeYear"
				></el-date-picker>
			</el-form-item>
			<el-form-item label="所属门店：">
				<el-select filterable v-model="formInline.storeKeyId" placeholder="全部门店" clearable size="small" @change="getListData">
					<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" size="small" icon="el-icon-search" @click="getListData">查询</el-button>
			</el-form-item>
		</el-form>
		<div class="statisticList">
			<div class="listTitle">{{ title }}</div>
			<el-table :cell-class-name="$moneyCellClass" v-loading="loading" :data="tableData" element-loading-text="加载中..." border stripe height="600" :row-class-name="tableRowClassName">
				<el-table-column prop="rowNumber" label="序号" align="center" width="60">
					<template #default="scope">
						{{ scope.row.isTotal ? "" : scope.row.rowNumber }}
					</template>
				</el-table-column>
				<el-table-column prop="storeName" label="所属门店" align="center" min-width="150" />
				<!-- 1-12 月，每月总收款 -->
				<el-table-column v-for="m in 12" :key="'month_' + m" :label="m + '月'" align="center" min-width="120">
					<template #default="scope">
						<span class="money-total">{{ formatMoney(scope.row["m" + m + "_total"]) }}</span>
					</template>
				</el-table-column>
				<!-- 全年合计 -->
				<el-table-column label="全年合计" align="center" min-width="140" fixed="right">
					<template #default="scope">
						<span class="money-sum">{{ formatMoney(scope.row.totalMoney) }}</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import { GetPayStoreYearStatistic } from "@/api/payApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";

export default {
	data() {
		const now = new Date();
		return {
			loading: false,
			title: "各门店按年收款金额统计",
			inputYear: "" + now.getFullYear(),
			formInline: {
				year: now.getFullYear(),
				storeKeyId: ""
			},
			storeList: [],
			tableData: []
		};
	},

	created() {
		this.GetOrgInfoListByConfig();
		this.getListData();
	},

	methods: {
		// 金额格式化
		formatMoney(val) {
			const num = parseFloat(val) || 0;
			return "￥" + num.toFixed(2) + " 元";
		},
		// 合计行高亮
		tableRowClassName({ row }) {
			return row.isTotal ? "total-row" : "";
		},
		// 选择年份
		changeYear() {
			this.formInline.year = parseInt(this.inputYear);
			this.getListData();
		},
		// 获取统计数据
		getListData() {
			this.loading = true;
			this.tableData = [];
			GetPayStoreYearStatistic(this.formInline)
				.then((res) => {
					if (res.code == 1 && res.data) {
						this.title = res.data.title;
						this.tableData = this.buildTableData(res.data.items || []);
					} else {
						this.tableData = [];
						this.$message({ type: "info", message: res.msg });
					}
				})
				.catch(() => {
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 把后台 items 转成表格行（每月金额平铺到 m{n}_total 字段）
		buildTableData(items) {
			let seq = 0;
			return items.map((item) => {
				const row = {
					storeName: item.storeName,
					isTotal: item.isTotal,
					rowNumber: item.isTotal ? "" : ++seq,
					totalMoney: item.totalMoney
				};
				if (item.monthList && Array.isArray(item.monthList)) {
					item.monthList.forEach((mon) => {
						row["m" + mon.month + "_total"] = mon.totalMoney;
					});
				}
				return row;
			});
		},
		// 获取门店列表
		GetOrgInfoListByConfig() {
			GetOrgInfoListByConfig({ key: 1 })
				.then((res) => {
					if (res.code == 1) {
						this.storeList = (res.data || []).map((item) => ({
							keyId: item.keyId,
							value: item.name + (item.remark2 ? "【" + item.remark2 + "】" : "")
						}));
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch(() => {
					this.$message.error("获取门店信息失败!");
				});
		}
	}
};
</script>

<style scoped lang="scss">
.statisticList {
	width: 100%;
	margin-top: 10px;
	padding: 20px;
	background-color: #fff;
	border-radius: 10px;
	box-sizing: border-box;
}

.listTitle {
	text-align: center;
	font-size: 18px;
	color: #333;
	font-weight: 700;
	margin-bottom: 16px;
}

.money-total {
	color: #07c160;
	font-weight: 600;
	white-space: nowrap;
}

.money-sum {
	color: #f56c6c;
	font-weight: bold;
	white-space: nowrap;
}

.statisticList ::v-deep .total-row {
	background-color: #fdf6ec;
	font-weight: bold;
}

.statisticList ::v-deep .total-row td {
	color: #e6a23c;
}
</style>
